import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

const useScrollToError = (name: string) => {
    const form = useFormContext();

    useEffect(() => {
        const error = form.formState.errors[name];
        if (error) {
            const element = document.querySelector(`input[name="${name}"]`);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }, [form.formState.errors[name]]);
};

export default useScrollToError;
